import { ReactElement } from 'react';
import UpdatePageLayout from '../ui/layout/form/FormPage/UpdatePageLayout';
import type { FormPageLayoutProps } from '../ui/layout/FormPageLayout/FormPageLayout';
import SensitiveDataPlug from './SensitiveDataPlug';
import ToggleSensitiveDataButton from './buttons/ToggleSensitiveDataButton';
import type { ToggleSensitiveDataButtonProps } from './buttons/ToggleSensitiveDataButton';
import useSensitiveDataService from './sensitiveDataService';

interface SensitiveUpdatePageLayoutProps {
  title?: string;
  titleVariant?: 'h2' | 'h4';
  titleActions?: ReactElement[];
  hideActionsOnHiddenData?: boolean;
  children?: ReactElement | ReactElement[];
  timerId?: string;
  toggleSensitiveDataButtonProps?: Partial<ToggleSensitiveDataButtonProps>;
  [key: string]: any;
}

const SensitiveUpdatePageLayout: React.FC<SensitiveUpdatePageLayoutProps> = ({
  titleActions = [],
  children,
  timerId,
  toggleSensitiveDataButtonProps,
  hideActionsOnHiddenData = false,
  ...other
}) => {
  const { isTimerActive, isShown, toggleSensitiveData, isSensitiveDataLoading } = useSensitiveDataService({ timerId });

  const getActions = () => {
    const buttonsArray = hideActionsOnHiddenData && !isShown ? [] : [...titleActions];
    const toggleButton = (
      <ToggleSensitiveDataButton
        key="toggle-sensitive-data"
        isShown={isShown}
        onClick={() => toggleSensitiveData([])}
        disabled={isSensitiveDataLoading}
        isTimerActive={isTimerActive}
        {...toggleSensitiveDataButtonProps}
      />
    );

    buttonsArray.unshift(toggleButton);

    return buttonsArray;
  };

  return (
    <UpdatePageLayout titleActions={getActions()} {...(other as FormPageLayoutProps)}>
      {(isShown ? children : <SensitiveDataPlug />) as ReactElement}
    </UpdatePageLayout>
  );
};

export default SensitiveUpdatePageLayout;
